var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnetship(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.896%",
    y1: "50%",
    x2: "65.659%",
    y2: "-7.527%",
    id: "partnetship_svg__svg-4137747669a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0L0 16.233l11.466 4.5V30l5.466-7.133 6.167 2.4L30 0zm-4.233 3.9l-13.8 15.534-8.633-3.4L25.767 3.9zM12.833 25.934v-4.667l2.767 1.066-2.767 3.6zm.5-5.968l14.133-15.9-5.3 19.368-8.833-3.468z",
    fill: "#00264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0L0 16.233l11.466 4.5V30l5.466-7.133 6.167 2.4L30 0zm-4.233 3.9l-13.8 15.534-8.633-3.4L25.767 3.9zM12.833 25.934v-4.667l2.767 1.066-2.767 3.6zm.5-5.968l14.133-15.9-5.3 19.368-8.833-3.468z",
    fill: "url(#partnetship_svg__svg-4137747669a)",
    opacity: 0
  }))));
}

export default SvgPartnetship;